export default "<p>user-edit-modal works!</p>\r\n";